import type { Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  debug: true,
  authStrategy: 'local',
  api: {
    graphql: 'https://app-qa-api.tradichem.es/graphql',
    rest: 'https://app-qa-api.tradichem.es/api',
  },
  lang: {
    base: 'es',
    fallback: 'es',
    langs: ['es', 'en'],
  },
  calendar: {
    weekStartsOn: 1,
  },
  oAuth: {
    applicationCode: 'aurora',
  },
  appearance: {
    brand: { name: 'Aurora', subtitle: 'Catalyst' },
    theme: 'theme-neutral',
    layout: '',
    themeSelector: true,
    palettes: [
      { id: 'theme-neutral', label: 'Neutral' },
      {
        id: 'theme-amber-minimal',
        label: 'Amber',
        fontHref:
          'https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Source+Serif+4:wght@100..900&family=JetBrains+Mono:wght@100..900&display=swap',
      },
      {
        id: 'theme-avvale',
        label: 'Avvale',
        fontHref:
          'https://fonts.googleapis.com/css2?family=72:wght@100..900&family=72Mono:wght@100..900&display=swap',
      },
      {
        id: 'theme-modern-minimal',
        label: 'Modern minimal',
        fontHref:
          'https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Source+Serif+4:wght@100..900&family=JetBrains+Mono:wght@100..900&display=swap',
      },
      {
        id: 'theme-sap',
        label: 'Sap',
        fontHref:
          'https://fonts.googleapis.com/css2?family=72:wght@100..900&family=72Mono:wght@100..900&display=swap',
      },
      {
        id: 'theme-sap-flat',
        label: 'Sap Flat',
        fontHref:
          'https://fonts.googleapis.com/css2?family=72:wght@100..900&family=72Mono:wght@100..900&display=swap',
      },
      {
        id: 'theme-sap-minimal',
        label: 'Sap Minimal',
        fontHref:
          'https://fonts.googleapis.com/css2?family=72:wght@100..900&family=72Mono:wght@100..900&display=swap',
      },
    ],
  },
};
